module.exports = __webpack_public_path__ + "static/4-dda7dd0d0e2618d1f65f24741e6d2598.jpg";